import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { UtilityFunctions } from '../../utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { actionCreators, State } from "../../store";
import { cookieService, userService } from '../../_services';
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';
import SuccessToast from '../../components/successToast';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { checkData } from "../../utils/checkData";
import { api } from "../../middleware/api";
import selectPlan_5 from '../Signup/selectPlan_5';

// Styles object
const styles = {
    container: {
        backgroundColor: '#1a1a2e',
        minHeight: '100vh',
    },
    topBar: {
        background: 'rgba(255, 255, 255, 0.05)',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
    },
    topBarTitle: {
        color: '#ffffff',
        margin: 0,
        fontSize: '24px',
        fontWeight: '500',
    },
    blueBox: {
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
    },
    whiteText: {
        color: '#ffffff',
    },
    mutedText: {
        color: 'rgba(255, 255, 255, 0.6)',
    },
    affiliateCodeBox: {
        background: 'linear-gradient(135deg, rgba(6, 239, 197, 0.2) 0%, rgba(0, 123, 255, 0.2) 100%)',
        borderRadius: '12px',
        padding: '30px',
        textAlign: 'center',
        marginBottom: '24px',
        border: '1px solid rgba(6, 239, 197, 0.3)',
    },
    affiliateCode: {
        fontSize: '36px',
        fontWeight: '700',
        color: '#06EFC5',
        letterSpacing: '3px',
        margin: '10px 0',
    },
    copyButton: {
        backgroundColor: 'rgba(6, 239, 197, 0.1)',
        border: '1px solid #06EFC5',
        color: '#06EFC5',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        marginLeft: '15px',
        transition: 'all 0.3s ease',
    },
    urlBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '6px',
        padding: '12px 20px',
        marginTop: '20px',
    },
    urlText: {
        color: '#ffffff',
        fontSize: '16px',
        marginRight: '10px',
        fontFamily: 'monospace',
    },
    table: {
        width: '100%',
        color: '#fff',
        borderCollapse: 'separate',
        borderSpacing: '0 8px',
    },
    tableHeader: {
        color: 'rgba(255, 255, 255, 0.6)',
        fontWeight: '500',
        padding: '15px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        textAlign: 'left',
    },
    tableCell: {
        padding: '15px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        color: '#fff',
    },
    badge: {
        padding: '6px 12px',
        borderRadius: '4px',
        fontWeight: '500',
        display: 'inline-block',
    },
    pendingBadge: {
        backgroundColor: 'rgba(255, 193, 7, 0.2)',
        color: '#ffc107',
    },
    confirmedBadge: {
        backgroundColor: 'rgba(40, 167, 69, 0.2)',
        color: '#28a745',
    },
    button: {
        padding: '8px 16px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#fff',
    },
    primaryButton: {
        backgroundColor: '#007bff',
    },
    marketingItem: {
        padding: '15px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    marketingItemTitle: {
        color: '#ffffff',
        fontSize: '16px',
        fontWeight: '500',
    },
    marketingItemDescription: {
        color: 'rgba(255, 255, 255, 0.6)',
        fontSize: '14px',
        marginTop: '5px',
    },
    infoBox: {
        backgroundColor: 'rgba(0, 123, 255, 0.1)',
        border: '1px solid rgba(0, 123, 255, 0.3)',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
    },
    infoTitle: {
        color: '#ffffff',
        fontSize: '18px',
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    infoPoint: {
        display: 'flex',
        marginBottom: '10px',
    },
    infoIcon: {
        color: '#06EFC5',
        marginRight: '10px',
        fontSize: '16px',
    },
    infoText: {
        color: 'rgba(255, 255, 255, 0.8)',
    },
    statsCard: {
        textAlign: 'center',
        padding: '20px',
    },
    statsNumber: {
        fontSize: '36px',
        fontWeight: '700',
        color: '#06EFC5',
        marginBottom: '5px',
    },
    statsLabel: {
        color: 'rgba(255, 255, 255, 0.6)',
        fontSize: '14px',
    },
    contactButton: {
        backgroundColor: 'rgba(6, 239, 197, 0.1)',
        border: '1px solid #06EFC5',
        color: '#06EFC5',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'all 0.3s ease',
    },
    settingsButton: {
        backgroundColor: '#06EFC5',
        color: '#1a1a2e',
        padding: '10px 20px',
        borderRadius: '4px',
        border: 'none',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
    },
    videoContainer: {
        position: 'relative',
        width: '100%',
        maxWidth: '560px',
        margin: '15px 0',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    videoThumbnail: {
        width: '100%',
        height: 'auto',
        borderRadius: '8px',
    },
    playButton: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60px',
        height: '60px',
        backgroundColor: 'rgba(6, 239, 197, 0.8)',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    playIcon: {
        width: 0,
        height: 0,
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent',
        borderLeft: '18px solid #1a1a2e',
        marginLeft: '5px',
    },
    downloadButton: {
        backgroundColor: '#06EFC5',
        color: '#1a1a2e',
        padding: '12px 24px',
        borderRadius: '4px',
        border: 'none',
        fontWeight: '600',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        margin: '20px auto',
        fontSize: '16px',
        transition: 'all 0.3s ease',
    },
    loginButton: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: '#ffffff',
        padding: '6px 12px',
        borderRadius: '4px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        cursor: 'pointer',
        fontSize: '14px',
        marginLeft: '10px',
    }
};

// Marketing materials data with added videos and download
const MARKETING_MATERIALS = [
    {
        id: 1,
        title: 'Marketing Materials Pack',
        description: 'Complete set of marketing materials including logos, banners, drops, comparisons, and more.',
        url: '/assets/affiliate/MPLOIAccountsReceivableAffiliateMarketing.zip',
        type: 'download'
    },
    {
        id: 2,
        title: 'MPLOI Short Description',
        description: 'A concise overview of MPLOI Accounts Receivable for quick pitches.',
        content: 'MPLOI Accounts Receivable: AI-powered collection calls that recover outstanding invoices automatically, saving you time and improving cash flow.',
        type: 'text'
    },
    {
        id: 3,
        title: 'MPLOI Long Description',
        description: 'Detailed explanation of MPLOI AR features and benefits.',
        content: 'MPLOI Accounts Receivable revolutionizes how businesses handle collections. Our AI-powered system automatically calls customers with overdue invoices, using natural conversation to arrange payments. With seamless integration to accounting platforms, customizable voice and personality settings, and detailed analytics, MPLOI AR reduces your admin workload while improving cash flow. The system handles follow-ups, payment arrangements, and even difficult conversations - all without requiring additional staff.',
        type: 'text'
    },
    {
        id: 4,
        title: 'Product Demo Video - Baz from accounts',
        description: 'See MPLOI AR in action with this comprehensive demo.',
        url: 'https://www.youtube.com/watch?v=nliPgfKz1Os',
        thumbnailUrl: 'https://img.youtube.com/vi/nliPgfKz1Os/maxresdefault.jpg',
        type: 'video'
    },
    {
        id: 5,
        title: 'Human vs AI - Accounts receivable demo',
        description: 'See a challenge vs AI.',
        url: 'https://youtu.be/W2J5h5vhAfU',
        thumbnailUrl: 'https://img.youtube.com/vi/W2J5h5vhAfU/maxresdefault.jpg',
        type: 'video'
    },
    {
        id: 6,
        title: 'How good is Steve from accounts?',
        description: 'See a challenge vs AI.',
        url: 'https://youtu.be/psdciFVMNfY',
        thumbnailUrl: 'https://img.youtube.com/vi/psdciFVMNfY/maxresdefault.jpg',
        type: 'video'
    },
];

const ARAffiliates = (props) => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const [userData, setUserData] = useState(null);
    const { setUnreadNotificationCount } = bindActionCreators(actionCreators, dispatch);
    const [showGuestAccessPrompt, setShowGuestAccessPrompt] = useState(false);
    const [unreadMsgCount, setUnreadMsgCount] = useState(0);
    const user = cookieService?.getCookie(STRING_CONSTANTS?.cookieStrings?.user);
    const isUserLoggedIn = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.token);
    
    // Affiliate data
    const [affiliateCode, setAffiliateCode] = useState('');
    const [affiliateUrl, setAffiliateUrl] = useState(``);
    const [referrals, setReferrals] = useState([]);
    const [copiedCode, setCopiedCode] = useState(false);
    const [copiedUrl, setCopiedUrl] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    
    // Stats
    const [stats, setStats] = useState({
        totalReferrals: 0,
        paidReferrals: 0,
        totalCommission: 0
    });

    const { resetState, closeOnlineOfflineSocket } = bindActionCreators(
      actionCreators,
      dispatch
    );
    
    const handleLogout = (e) => {
      e.preventDefault();
      closeOnlineOfflineSocket(true);
      userService
        .logout()
        .then((res) => {
          api
            .deleteApi("device-token/", {
              deviceType: "WEB",
              token: `${cookieService.getCookie("fcm")}`,
            })
            .then((res) => {
              cookieService.removeAllCookies();
              props.history.push(STRING_CONSTANTS.navigationString.login);
              resetState();
            })
            .catch((e) => {
              cookieService.removeAllCookies();
              props.history.push(STRING_CONSTANTS.navigationString.login);
              resetState();
            });
        })
        .catch((err) => {
          checkData(props, "/", err);
        });
    };

    // Fetch affiliate data from API
    const fetchAffiliateData = async () => {
        setIsLoading(true);
        try {
            // Get user data first
            const userData = await userService.getUserData();
            cookieService.saveCookie(STRING_CONSTANTS.cookieStrings.user, userData);
            setUnreadNotificationCount(userData?.user?.unreadNotificationCount);

            // Extract affiliate code from referral link
            setUserData(userData);

            // Get referrals data
            const affiliateResponse = await userService.aiRequest({
                method: 'get-affiliate-data',
                data: {  }  // Limit to 50 most recent interactions
            });
            console.log("Affiliate data fetched successfully", affiliateResponse);
            if (affiliateResponse && affiliateResponse.data) {
                setReferrals(affiliateResponse.data.referrals || []);

                const code = affiliateResponse.data.code || '';
                setAffiliateCode(code);
                setAffiliateUrl(`https://mploi.com/r/${code}`);
    
                setStats({
                    totalReferrals: affiliateResponse.data.totalReferrals || 0,
                    paidReferrals: affiliateResponse.data.paidReferrals || 0,
                    totalCommission: affiliateResponse.data.totalCommission || 0,
                });
            }

        } catch (error) {
            console.error("Error fetching affiliate data:", error);
            // If API fails, use empty data
            setReferrals([]);
            setStats({
                totalReferrals: 0,
                confirmedReferrals: 0,
                totalCommission: 0
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isUserLoggedIn) {
            fetchAffiliateData();
        }
    }, []);

    const handleCopyCode = () => {
        setCopiedCode(true);
        setTimeout(() => setCopiedCode(false), 2000);
        SuccessToast("Success", "Affiliate code copied to clipboard!");
    };

    const handleCopyUrl = () => {
        setCopiedUrl(true);
        setTimeout(() => setCopiedUrl(false), 2000);
        SuccessToast("Success", "Affiliate URL copied to clipboard!");
    };

    const handleContactCustomer = (referral) => {
        SuccessToast("Contact Initiated", `Contacting ${referral.contactName} from ${referral.companyName}`);
    };
    
    const handleLoginToAccount = (referral) => {
        SuccessToast("Login", `Logging into ${referral.companyName}'s demo account`);
    };
    
    const handleVideoClick = (videoUrl) => {
        window.open(videoUrl, '_blank');
    };
    
    const handleDownload = (url) => {
        SuccessToast("Download Started", "Your marketing materials pack is downloading");
        window.location.href = url;
    };
    
    const navigateToSettings = () => {
        props.history.push('/ar/affiliate/settings');
    };

    return (
        <section className="main-dashboard-wrap" style={styles.container}>
            <Helmet>
                <title>MPLOI: Affiliate Program Dashboard</title>
            </Helmet>
            <div id="wrapper" style={{ height: "100vh" }}>
                {/* Sidebar */}
                <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${state.common.showSidebarOnMobileView ? "active" : ""}`} id="accordionSidebar">
                    <div>
                        <Link style={{ pointerEvents: "none" }} className="sidebar-brand d-flex align-items-center justify-content-center" to="#">
                            <img src={UtilityFunctions.getImageURL() + "db-logo.svg"} alt="Logo" />
                        </Link>
                        {!user?.user?.isAccountsSignup && <li className="nav-item">
                            <Link className="nav-link" to="/ar/affiliate/dashboard">
                                <img src={UtilityFunctions.getImageURL() + "home-icon-blank-white.svg"} alt="" />
                                <img src={UtilityFunctions.getImageURL() + "home-icon-fill-green.svg"} alt="" />
                            </Link>
                        </li>}
                    </div>

                    <div>
                        <li className='d-grid justify-content-center gap-2 text-white'>
                            <span style={{ cursor: "pointer" }}
                                onClick={handleLogout}
                            >
                                Logout
                            </span>
                        </li>
                    </div>
                </ul>

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <br />
                        {/* Top Bar */}
                        {/* <div style={styles.topBar}>
                            <h1 style={styles.topBarTitle}>MPLOI Accounts Receivable Affiliate Program</h1>
                            <div>
                                <button 
                                    style={styles.settingsButton} 
                                    onClick={navigateToSettings}
                                >
                                    Demo Accounts
                                </button>
                                &nbsp;&nbsp;
                                <button 
                                    style={styles.settingsButton} 
                                    onClick={navigateToSettings}
                                >
                                    Affiliate Settings
                                </button>
                            </div>
                        </div> */}

                        {/* Top Bar with Affiliate Information */}
                        <div style={{
                            background: 'linear-gradient(135deg, rgba(26, 26, 46, 0.95) 0%, rgba(26, 26, 46, 0.8) 100%)',
                            padding: '24px',
                            borderRadius: '12px',
                            marginBottom: '24px',
                            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                            border: '1px solid rgba(6, 239, 197, 0.2)',
                        }}>
                            <div className="row align-items-center">
                                <div className="col-lg-8">
                                    <h1 style={{...styles.whiteText, fontSize: '28px', marginBottom: '12px', fontWeight: '600'}}>
                                        MPLOI Accounts Receivable Affiliate Program
                                    </h1>
                                    <p style={{...styles.whiteText, opacity: '0.8', fontSize: '16px', lineHeight: '1.6'}}>
                                        Share your unique affiliate link with potential customers. When they sign up for MPLOI Accounts Receivable, 
                                        you'll earn <span style={{color: '#06EFC5', fontWeight: '600'}}>$997.50</span> commission for each confirmed subscription.
                                        Track your referrals and earnings directly from this dashboard.
                                    </p>
                                    
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginTop: '16px',
                                        background: 'rgba(6, 239, 197, 0.1)',
                                        padding: '12px 16px',
                                        borderRadius: '8px',
                                        border: '1px solid rgba(6, 239, 197, 0.3)'
                                    }}>
                                        <div style={{marginRight: '12px'}}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 7H13V13H11V7ZM11 15H13V17H11V15Z" fill="#06EFC5"/>
                                            </svg>
                                        </div>
                                        <p style={{...styles.whiteText, margin: 0, fontSize: '18px'}}>
                                            Your affiliate link: <span style={{fontWeight: '500', color: '#06EFC5'}}>{affiliateUrl || 'Loading...'}</span>
                                            <CopyToClipboard text={affiliateUrl} onCopy={handleCopyUrl}>
                                                <button style={{
                                                    ...styles.copyButton, 
                                                    marginLeft: '12px',
                                                    padding: '4px 12px',
                                                    fontSize: '13px'
                                                }}>
                                                    {copiedUrl ? 'Copied!' : 'Copy Link'}
                                                </button>
                                            </CopyToClipboard>
                                        </p>
                                    </div>
                                </div>
                                
                                <div className="col-lg-4">
                                    <div style={{
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        borderRadius: '10px',
                                        padding: '20px',
                                        border: '1px solid rgba(255, 255, 255, 0.1)'
                                    }}>
                                        <h4 style={{...styles.whiteText, fontSize: '18px', marginBottom: '16px', fontWeight: '500'}}>
                                            Affiliate Options
                                        </h4>
                                        
                                        <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                                            <button 
                                                style={{
                                                    backgroundColor: 'rgba(6, 239, 197, 0.15)',
                                                    color: '#06EFC5',
                                                    padding: '12px 16px',
                                                    borderRadius: '6px',
                                                    border: '1px solid rgba(6, 239, 197, 0.3)',
                                                    fontWeight: '500',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    textAlign: 'left'
                                                }}
                                                onClick={navigateToSettings}
                                            >
                                                <span>Adjust Settings</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.3 5.2L8 10.5L2.7 5.2L1.3 6.6L8 13.3L14.7 6.6L13.3 5.2Z" fill="#06EFC5"/>
                                                </svg>
                                            </button>
                                            
                                            <button 
                                                style={{
                                                    backgroundColor: 'rgba(6, 239, 197, 0.15)',
                                                    color: '#06EFC5',
                                                    padding: '12px 16px',
                                                    borderRadius: '6px',
                                                    border: '1px solid rgba(6, 239, 197, 0.3)',
                                                    fontWeight: '500',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    textAlign: 'left'
                                                }}
                                                onClick={() => props.history.push('/ar/affiliate/demos')}
                                            >
                                                <span>Manage Demo Accounts</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.3 5.2L8 10.5L2.7 5.2L1.3 6.6L8 13.3L14.7 6.6L13.3 5.2Z" fill="#06EFC5"/>
                                                </svg>
                                            </button>
                                            
                                            <button 
                                                style={{
                                                    backgroundColor: '#06EFC5',
                                                    color: '#1a1a2e',
                                                    padding: '12px 16px',
                                                    borderRadius: '6px',
                                                    border: 'none',
                                                    fontWeight: '600',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between'
                                                }}
                                                onClick={() => handleDownload('/assets/affiliate/MPLOIAccountsReceivableAffiliateMarketing.zip')}
                                            >
                                                <span>Download Marketing Pack</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM0 16V11H2V14H14V11H16V16H0Z" fill="#1a1a2e"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="container-fluid">
                            {/* Affiliate Code Section */}
                            {/* <div style={styles.affiliateCodeBox}>
                                <h3 style={styles.whiteText}>Your Affiliate Code</h3>
                                <div style={styles.affiliateCode}>{affiliateCode || 'Loading...'}</div>
                                <CopyToClipboard text={affiliateCode} onCopy={handleCopyCode}>
                                    <button style={styles.copyButton}>
                                        {copiedCode ? 'Copied!' : 'Copy Code'}
                                    </button>
                                </CopyToClipboard>
                                
                                <div style={styles.urlBox}>
                                    <span style={styles.urlText}>{affiliateUrl || 'Loading...'}</span>
                                    <CopyToClipboard text={affiliateUrl} onCopy={handleCopyUrl}>
                                        <button style={styles.copyButton}>
                                            {copiedUrl ? 'Copied!' : 'Copy URL'}
                                        </button>
                                    </CopyToClipboard>
                                </div>
                            </div> */}

                            {/* Stats Cards */}
                            <div className="row mb-4">
                                <div className="col-xl-4 col-md-4">
                                    <div style={styles.blueBox}>
                                        <div style={styles.statsCard}>
                                            <div style={styles.statsNumber}>
                                                {isLoading ? '...' : stats.totalReferrals}
                                            </div>
                                            <div style={styles.statsLabel}>Total Referrals</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4">
                                    <div style={styles.blueBox}>
                                        <div style={styles.statsCard}>
                                            <div style={styles.statsNumber}>
                                                {isLoading ? '...' : stats.paidReferrals}
                                            </div>
                                            <div style={styles.statsLabel}>Paid Referrals</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4">
                                    <div style={styles.blueBox}>
                                        <div style={styles.statsCard}>
                                            <div style={styles.statsNumber}>
                                                {isLoading ? '...' : `$${stats.totalCommission.toFixed(2)}`}
                                            </div>
                                            <div style={styles.statsLabel}>Total Commission</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Referrals Table */}
                            <div style={styles.blueBox}>
                                <h3 style={{...styles.whiteText, marginBottom: '20px'}}>
                                    Your Referrals
                                </h3>
                                <div className="table-responsive">
                                    {isLoading ? (
                                        <p style={styles.whiteText}>Loading referrals data...</p>
                                    ) : referrals.length > 0 ? (
                                        <table style={styles.table}>
                                            <thead>
                                                <tr>
                                                    <th style={styles.tableHeader}>Status</th>
                                                    <th style={styles.tableHeader}>Referred</th>
                                                    <th style={styles.tableHeader}>Company</th>
                                                    <th style={styles.tableHeader}>Contact</th>
                                                    <th style={styles.tableHeader}>Commission</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {referrals.map(referral => (
                                                    <tr key={referral.id}>
                                                        <td style={styles.tableCell}>
                                                            <span style={{
                                                                ...styles.badge,
                                                                ...(referral.status === 'PAID' ? styles.confirmedBadge : styles.pendingBadge)
                                                            }}>
                                                                {referral.status}
                                                            </span>
                                                        </td>
                                                        <td style={styles.tableCell}>
                                                            {moment(referral.dateReferred).format('DD/MM/YYYY')}
                                                        </td>
                                                        <td style={styles.tableCell}>{referral.companyName}</td>
                                                        <td style={styles.tableCell}>
                                                            <div>{referral.contactName}</div>
                                                            <div style={styles.mutedText}>{referral.email}</div>
                                                        </td>
                                                        <td style={styles.tableCell}>
                                                            {referral.status === 'PAID' ? 
                                                                `$${referral.commission.toFixed(2)}` : 
                                                                '—'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <p style={styles.whiteText}>No referrals found. Start sharing your affiliate link to earn commissions!</p>
                                    )}
                                </div>
                            </div>

                            {/* Marketing Materials Section */}
                            <div style={styles.blueBox}>
                                <h3 style={{...styles.whiteText, marginBottom: '20px'}}>
                                    Marketing Materials
                                </h3>
                                
                                {MARKETING_MATERIALS.map((material) => (
                                    <div key={material.id} style={styles.marketingItem}>
                                        <div style={{width: material.type === 'video' ? '70%' : 'auto'}}>
                                            <h4 style={styles.marketingItemTitle}>{material.title}</h4>
                                            <p style={styles.marketingItemDescription}>{material.description}</p>
                                            
                                            {material.type === 'text' && (
                                                <div style={{
                                                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                                    padding: '15px',
                                                    borderRadius: '6px',
                                                    marginTop: '10px',
                                                    color: '#ffffff'
                                                }}>
                                                    {material.content}
                                                </div>
                                            )}
                                            
                                            {material.type === 'video' && (
                                                <div 
                                                    style={styles.videoContainer}
                                                    onClick={() => handleVideoClick(material.url)}
                                                >
                                                    <img 
                                                        src={material.thumbnailUrl} 
                                                        alt={material.title}
                                                        style={styles.videoThumbnail}
                                                    />
                                                    <div style={styles.playButton}>
                                                        <div style={styles.playIcon}></div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        
                                        {material.type === 'download' && (
                                            <button 
                                                style={styles.downloadButton}
                                                onClick={() => handleDownload(material.url)}
                                            >
                                                <span>Download Marketing Pack</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM0 16V11H2V14H14V11H16V16H0Z" fill="#1a1a2e"/>
                                                </svg>
                                            </button>
                                        )}
                                        
                                        {material.type === 'video' && (
                                            <a 
                                                href={material.url} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={styles.copyButton}
                                            >
                                                Watch Video
                                            </a>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Affiliate Program Info */}
                            <div style={styles.infoBox}>
                                <h3 style={styles.infoTitle}>
                                    How Our Affiliate Program Works
                                </h3>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Commission Structure:</strong> Earn $997.50 for each confirmed referral that subscribes to MPLOI Accounts Receivable or pass on a discount to your referrals.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>30-Day Cookie:</strong> Your referrals are tracked for 30 days from their first visit using your affiliate link.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Payment Terms:</strong> Commissions are paid monthly for all confirmed referrals from the previous month.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Confirmation Process:</strong> Referrals are confirmed after they complete their first month's subscription.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Marketing Support:</strong> Use our provided marketing materials to promote MPLOI effectively.
                                    </p>
                                </div>
                                
                                <div style={styles.infoPoint}>
                                    <span style={styles.infoIcon}>✓</span>
                                    <p style={styles.infoText}>
                                        <strong>Tracking:</strong> All referrals are automatically tracked through your unique affiliate code.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ARAffiliates;